import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import ProjectDetails from "../Projects/UI/ProjectDetails";
import ProjectInformation from "../Projects/UI/ProjectInformation";
import ProjectsTranslations from "../Projects/UI/ProjectsTranslations";
import ProjectUploadImage from "../Projects/UI/ProjectUploadImage";
import { getSelectedProjectSelector } from "../Projects/Infrastructure/Projects.reducer";
import { getProject } from "../Projects/Application/Projects.business";
import { CustomCard } from "../Utils/UI/Text";
import { ProfileOutlined, CloudOutlined } from "@ant-design/icons";
import { Collapse, Space, Tabs } from "antd";
import InnerSection from "./InnerSection";
import { useLocation, useNavigate } from "react-router-dom";
import { PageHeader } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "./FullProjectDetail.css";

const { Panel } = Collapse;
const { TabPane } = Tabs;

const FullProjectDetail = ({ id, onBack }) => {
  useEffect(() => {
    if (id) getProject(id);
  }, [id]);
  const navigate = useNavigate();
  const location = useLocation();

  const record = useSelector(getSelectedProjectSelector);
  if (!record) return null;

  const projectTitle =
    record.name || record.comercial_name || record.project_name || "";

  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate("/projects");
    }
  };
  return (
    <>
      <PageHeader
        className="site-page-header"
        backIcon={false}
        title={
          <button
            className="back-btn-pro"
            onClick={() => handleBack()}
            aria-label="Regresar a Projects"
          >
            <ArrowLeftOutlined className="back-btn-icon" />
            <span className="back-btn-text">Regresar</span>
          </button>
        }
      />

      <CustomCard>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Collapse
            collapsible="icon"
            bordered={false}
            defaultActiveKey={["1"]}
            className="custom-collapse"
          >
            <Panel
              header={
                <span style={{ fontWeight: 500 }}>
                  <ProfileOutlined
                    style={{ marginRight: 8, color: "#1677ff" }}
                  />
                  {projectTitle
                    ? `${projectTitle}: Project Details`
                    : "Project Details"}
                </span>
              }
              key="1"
            >
              <ProjectDetails record={record} />

              <Tabs defaultActiveKey="1" centered>
                <TabPane tab="Traducciones" key="1">
                  <InnerSection>
                    <ProjectsTranslations record={record} />
                  </InnerSection>
                </TabPane>

                <TabPane tab="Imagen del Proyecto" key="2">
                  <InnerSection>
                    <ProjectUploadImage record={record} />
                  </InnerSection>
                </TabPane>
              </Tabs>
            </Panel>
          </Collapse>

          <Collapse
            collapsible="icon"
            bordered={false}
            defaultActiveKey={["2"]}
            className="custom-collapse"
          >
            <Panel
              header={
                <span style={{ fontWeight: 500 }}>
                  <CloudOutlined style={{ marginRight: 8, color: "#52c41a" }} />
                  Carbon Credits
                </span>
              }
              key="2"
            >
              <ProjectInformation record={record} />
            </Panel>
          </Collapse>
        </Space>
      </CustomCard>
    </>
  );
};

export default FullProjectDetail;
